<template>
  <el-dialog
    class="dialog-wrapper show-comments"
    :visible.sync="dialogVisible"
    :show-close="true"
    @close="abortAction"
  >
    <ContentHeader
      slot="title"
      :title="$t('analysesData.sampleComments')"
    />
    <div class="comments-container">
      <p>{{ sample?.comments }}</p>
    </div>

    <el-button
      type="secondary"
      @click="abortAction"
    >
      {{ $t('global.close') }}
    </el-button>
  </el-dialog>
</template>

<script>
  import ContentHeader from '@/components/ContentHeader.vue';

  export default {
    name: 'ShowComment',
    components: { ContentHeader },
    props: {
      sample: { type: Object, required: true },
      visible: { type: Boolean, default: false },
    },
    data() {
      return {
        dialogVisible: false,
      };
    },
    watch: {
      visible: {
        immediate: true,
        handler(val) {
          this.dialogVisible = val;
        },
      },
    },
    methods: {
      abortAction() {
        this.dialogVisible = false;
        this.$emit('update:visible', false);
        this.$emit('dialogClose');
      },
    },
  };
</script>

<style lang="scss">
  .show-comments {
    .el-dialog {
      width: 40%;
      min-width: 400px;
    }

    .comments-container {
      margin: 1rem 0;
      font-size: 16px;
      line-height: 20px;
      background-color: $--table-header-background-color;
      padding: 2rem 0;
    }

    .el-dialog .el-dialog__body {
      padding: 1rem 0;
    }

    .el-dialog__body p {
      padding: 0 20px;
    }

    .el-dialog__body button {
      margin-left: 20px;
    }
  }
</style>
